// extracted by mini-css-extract-plugin
export default {"Snackbar":"SnackBarAlert_Snackbar__RNaXt","viewNotification":"SnackBarAlert_viewNotification__S75WO","closeBanner":"SnackBarAlert_closeBanner__Pbmr8"};